




















































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Gestacao } from '../../../../back/src/entity/Gestacao';
import Carregando from '../../components/Carregando.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import TheGestacoesDados from '../../components/gestacoes/TheGestacoesDados.vue';
import GestacoesFinalizarForm from '../../components/gestacoes/GestacoesFinalizarForm.vue';

export default Vue.extend({
  name: 'PacientesFinalizarGestacao',
  components: {
    Carregando,
    ThePacientesResumo,
    TheGestacoesDados,
    GestacoesFinalizarForm,
  },
  data() {
    return {
      loading: {
        paciente: true,
      },
      paciente: null,
      gestacao: null,
      showDadosGestacao: true,
    };
  },
  computed: {
    previousRoute() {
      return this.$store.getters.previousRoute;
    },
    pacienteId(): number {
      return Number(this.$route.params.pacienteId);
    },
    gestacaoId(): number {
      return Number(this.$route.params.gestacaoId);
    },
  },
  async mounted() {
    await this.buscaPaciente();
  },
  methods: {
    async buscaPaciente() {
      this.loading.paciente = true;
      try {
        const response = await Requester.paciente.paciente(this.pacienteId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.paciente = response.data;
          if (this.gestacaoId > 0) {
            if (this.paciente.gestacao_atual
              && this.paciente.gestacao_atual === this.gestacaoId
            ) {
              this.gestacao = this.paciente.gestacao_atual;
            } else {
              this.gestacao = _.find(
                this.paciente.gestacoes as Gestacao[],
                gestacao => (gestacao.id === this.gestacaoId),
              );
            }
          } else {
            this.gestacao = null;
          }
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.paciente = false;
      }
    },
    gestacaoFinalizada(gestacao: Gestacao) {
      this.$emit('finaliza-gestacao', gestacao);
      if (this.previousRoute) {
        this.$router.push(this.previousRoute);
      } else {
        this.$router.push({ name: 'PacientesVer', params: { pacienteId: this.pacienteId } });
      }
    },
  },
});
